import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgStaticSpinner = (props) => /* @__PURE__ */ _jsx("svg", {
	width: "18px",
	height: "18px",
	viewBox: "0 0 18 18",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	...props,
	children: /* @__PURE__ */ _jsx("g", {
		id: "In-Progress-Pill-UXD-936",
		stroke: "none",
		strokeWidth: 1,
		fill: "none",
		fillRule: "evenodd",
		strokeLinecap: "round",
		strokeLinejoin: "round",
		children: /* @__PURE__ */ _jsx("g", {
			id: "In-Progress-Pill-Update",
			transform: "translate(-197.000000, -392.000000)",
			strokeWidth: 2,
			children: /* @__PURE__ */ _jsx("g", {
				id: "Step-Card--1--Has-Due-Date---Badge",
				transform: "translate(150.000000, 355.000000)",
				children: /* @__PURE__ */ _jsx("g", {
					id: "Step-Card-/-_Status-/-In-Progress",
					transform: "translate(32.000000, 30.000000)",
					children: /* @__PURE__ */ _jsxs("g", {
						id: "List-Progress---In-Progress",
						transform: "translate(16.000000, 8.000000)",
						children: [/* @__PURE__ */ _jsx("path", {
							d: "M8,16 C3.581722,16 0,12.418278 0,8 C0,3.581722 3.581722,0 8,0 C12.418278,0 16,3.581722 16,8 C16,12.418278 12.418278,16 8,16 Z",
							id: "Line",
							strokeOpacity: .5,
							stroke: "#9A9A9A"
						}), /* @__PURE__ */ _jsx("path", {
							d: "M8,0 C12.418278,0 16,3.581722 16,8",
							id: "Line-Copy",
							stroke: "#004C6C",
							fillRule: "nonzero"
						})]
					})
				})
			})
		})
	})
});
export default SvgStaticSpinner;
